// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1g4dn","loader":"style__loader___3Tbp6"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/booster-login-token/style.css
// module id = 1239
// module chunks = 0